export default __webpack_public_path__ + "static/media/bitblue.461d36c2.svg";